import $ from 'jquery';
import {Cookie} from "../utilities";
import {cashbackOrderCancel} from "../queries";

$('.ui-modal').on('show', function () {
    $(this).css('display', 'flex');
    let delay = 20;
    if ($(this).attr('data-show-delay')){
        setTimeout(() => {
            $(this).addClass('ui-modal--visible');
        }, parseInt($(this).attr('data-show-delay')));
    }else {
        setTimeout(() => {
            $(this).addClass('ui-modal--visible');
        }, delay);
    }


}).on('hide', function () {
    $(this).removeClass('ui-modal--visible popup-pending');
});

$('.ui-modal__close, .ui-modal__overlay').click(function () {
    $(this).parents('.ui-modal').trigger('hide');
    if ($(this).parents('.ui-modal').attr('data-redirect-after')){
        window.location = $(this).parents('.ui-modal').attr('data-redirect-after')
    }
    if ($(this).parents('.ui-modal').attr('data-name')==='login-order'){
        location.reload();
    }
    if ($(this).parents('.ui-modal').attr('data-name')==='basket-products-not-available' && location.pathname === '/order/'){
        location.reload();
    }
    if ($(this).parents('.ui-modal').attr('data-name')==='cashback-spend'){
        const response = cashbackOrderCancel();
        const cashbackValue = $('.js-bonuses-toggle');
        cashbackValue.prop('checked', false);
        const toggle = $('.page-order-checkout-toggle');
        const icon = toggle.find('.page-order-checkout-toggle__icon');
        setTimeout(()=>{
            icon.removeClass('loading');
        },1000)
        if (!response.isSuccess){
            console.log('refresh page!')
        }
    }
    showPopupLoad();
});

$('body').on('click','[data-modal-name]',function () {
    $('.ui-modal').trigger('hide');
    const name = $(this).attr('data-modal-name');
    $(`.ui-modal[data-name="${name}"]`).trigger('show');
});

$('.ui-modal').each((index, element) => {
    if ($(element).attr('data-page-show') === window.location.pathname || $(element).attr('data-page-show') === '*'){
        const name = $(element).attr('data-name');
        const getWindow = $(element).attr('data-result');
        $(element).addClass('popup-pending'); // Ожидание показа

        if (Cookie.get(`MODAL_PAGE_SHOWED_${name}_${getWindow}`)!==`MODAL_PAGE_SHOWED_${name}_${getWindow}`){
            //hardcode by popup field code
            if (name == 'account-suggestion'){
                const getBasket = $(element).attr('data-saved-basket');
                if (Cookie.get(`MODAL_PAGE_SHOWED_${name}_${getWindow}_${getBasket}`)!==`MODAL_PAGE_SHOWED_${name}_${getWindow}_${getBasket}`){
                    Cookie.set(`MODAL_PAGE_SHOWED_${name}_${getWindow}_${getBasket}`, `MODAL_PAGE_SHOWED_${name}_${getWindow}_${getBasket}`, false, 7);
                    showPopupLoad();
                } else {
                    return false;
                }
                return false;
            }

            Cookie.set(`MODAL_PAGE_SHOWED_${name}_${getWindow}`, `MODAL_PAGE_SHOWED_${name}_${getWindow}`, false, 7);
            showPopupLoad();
        }

    }
})

function showPopupLoad(){
    setTimeout(() => {
        $('.popup-pending').each((index, element) => {
            if($('.ui-modal--visible').length > 0) {
                return false;
            }
            $(element).trigger('show');
            return false;
        })
    })
}
